const getters = {
  getOrders: (state) => {
    return _.orderBy(state.incomingOrders, 'estimatedTimeOfArrival');
  },
  getOrder:(state)=>(id)=>{
    return state.incomingOrders[id];
  },
  getOrdersUnsorted: (state) => {
    return _.toArray(state.incomingOrders);
  },
  getAvailableSenders:(state,getters)=>{
    return _.sortBy(_.uniq(Object.keys(getters.getGroupedBySender)))
  },
  getGroupedBySender:(state)=>{

    let grouped =  _.groupBy(state.incomingOrders, (order)=>{
      return order.senderName
    });

    return grouped ? grouped : []
  },

};

export default getters;
